import { FC, ReactElement } from 'react';
import { Card, Grid, Paper, useMediaQuery } from '@mui/material';
import BakeasyHeaderLabel from '../../components/labels/BakeasyHeaderLabel';

export const Reports: FC = (): ReactElement => {
  const isMobile = useMediaQuery('(max-width:600px)');

  function suppliersUI() {
    return (
      <Grid style={{ padding: 1 }}>
        <Paper component={Card} variant="outlined">
          <Grid container>
            <BakeasyHeaderLabel message={'REPORTS'} />
          </Grid>

          {/* <Grid container padding={1}>
						<Grid>
							<BakeasyTextField
								label="Search"
								type="text"
								name="search"
								value={""}
								maxLength={10}
								fullWidth={false}
								onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
									//handleInputChange(event);
								}}
							/>
						</Grid>
						<Grid>
							<BakeasySelect
								disabled={false}
								label="Status"
								//value={""}
								statusOptions={statusOptions}
								onChange={
									(e) => {}
									// setDriverDetails({
									// 	...driverDetails,
									// 	status: e.target.value as string,
									// })
								}
							/>
						</Grid>
						<Grid>
							<BakeasyButton
								startIcon={<Add />}
								label={"Add Supplier"}
								onClick={function (
									event: React.MouseEvent<HTMLButtonElement, MouseEvent>
								): void {
									throw new Error("Function not implemented.");
								}}
							/>
						</Grid>
					</Grid>

					<Grid padding={2}>
						<BakeasyTable
							headCells={tableHeaders}
							tableData={[
								{
									id: 1,
									name: "Supplier 1",
									emailId: "supplier1@gmail.com",
									mobile: "9090909090",
									status: <BakeasyChip label={"Active"} />,
									actions: [
										<BakeasyChipEdit
											onClick={(event: any) => {
												event.stopPropagation();
												
											}}
										/>,
										<BakeasyChipDelete />,
									],
								},
								{
									id: 2,
									name: "Supplier 2",
									emailId: "supplier1@gmail.com",
									mobile: "898989889",
									status: <BakeasyChip label={"Active"} />,
									actions: [
										<BakeasyChipEdit
											onClick={(event: any) => {
												event.stopPropagation();
									
											}}
										/>,
										<BakeasyChipDelete />,
									],
								},
							]}
						/>
					</Grid> */}
        </Paper>
      </Grid>
    );
  }

  return suppliersUI();
};
